<template>
  <div class="enterprise">
    <div class="one1">
        <img class="icon" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/home_back7.jpg" alt="">
        <div class="one1_content">
            <div class="title_name title_name_one">在线金融系统</div>
            <div class="title_name title_name_two">在线 融资申请、赎货付款、费用结算、风控预警等一站式</div>
            <div class="title_name title_name_three">木材供应链金融解决方案</div>
        </div>
    </div>
    <div class="one2 content">
        <div class="titmeName">
            <div class="title">木材全流程在线金融系统</div>
            <div class="explainTitle">金融系统功能亮点</div>
        </div>
        <div class="enterprise_one2 enterprise_content">
            <div class="item wow animate__animated animate__fadeInUpBig"  v-for="(item,index) in one2List" :key="index">
                <div class="item_content">
                    <i class="icon iconfont" :class="item.icon"></i>
                    <div class="name">{{item.name}}</div>
                </div>
            </div>
        </div>
    </div>
    <template v-for="(item,index) in erpList">
        <div :key="index+'_erp'">
            <div v-if="(index+1)%2 !=0" class="content one3">
                <div class="one3_content enterprise_content">
                    <div class="left wow animate__animated animate__bounceInLeft" data-wow-duration ="0.6s" data-wow-delay ="0.4s">
                        <img :src="item.icon" alt="">
                    </div>
                    <div class="right">
                        <div class="item_list_content">
                            <div class="title">{{item.title}}</div>
                            <div class="explain">{{item.explain}}</div>
                            <div class="item_bottom">
                                <div class="ontrial"><img src="../../../../public/images/free.png" alt=""> 免费试用</div>
                                <div class="consult"><img class="be" src="../../../../public/images/consult.png" alt=""><img class="be_wh" src="../../../../public/images/consult_wh.png" alt=""> 详情咨询</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="one4 content">
                <div class="one4_content enterprise_content">
                    <div class="left">
                        <div class="item_list_content">
                            <div class="title">{{item.title}}</div>
                            <div class="explain">{{item.explain}}</div>
                            <div class="item_bottom">
                                <div class="ontrial"><img src="../../../../public/images/free.png" alt=""> 免费试用</div>
                                <div class="consult"><img class="be" src="../../../../public/images/consult.png" alt=""><img class="be_wh" src="../../../../public/images/consult_wh.png" alt=""> 详情咨询</div>
                            </div>
                        </div>
                    </div>
                    <div class="right wow animate__animated animate__bounceInRight" data-wow-duration ="0.6s" data-wow-delay ="0.4s">
                        <img :src="item.icon" alt="">
                    </div>
                </div>
            </div>
        </div>
    </template>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
export default {
    name: '',
    props: {
      
    },
    data(){
      return{
        one2List:[
          {
              name:'在线融资，操作简单',
              explain:'合同管控，结算灵活',
              icon:'iconzaixianrongzi',
              img:require('../../../../public/images/enterprise/enterprise_customer_icon.png'),
          },
          {
              name:'装车赎货，秒级完成',
              explain:'开单高效，跟进方便',
              icon:'iconzhuangcheshuhuo',
              img:require('../../../../public/images/enterprise/enterprise_sale_icon.png'),
          },
          {
              name:'费用账单，自动计算',
              explain:'业财一体，收付清晰',
              icon:'iconzidongjisuan',
              img:require('../../../../public/images/enterprise/enterprise_finance_icon.png'),
          },
          {
              name:'赎货付款，自动放行',
              explain:'库存锁货，管理省心',
              icon:'iconzidongfanghang',
              img:require('../../../../public/images/enterprise/enterprise_library_icon.png'),
          },
          {
              name:'发票管理，尽然有序',
              explain:'在线协同，流程客观',
              icon:'iconfapiaoguanli',
              img:require('../../../../public/images/enterprise/enterprise_carry_icon.png'),
          },
          {
              name:'多系统协同，便利高效',
              explain:'快速融资、便捷赎货',
              icon:'iconduoxitongxietong',
              img:require('../../../../public/images/enterprise/enterprise_melt_icon.png'),
          },
          {
              name:'电子合同，管理方便',
              explain:'客户分析、实时掌控',
              icon:'icondianzihetong',
              img:require('../../../../public/images/enterprise/enterprise_customer_icon.png'),
          },
          {
              name:'钱，物双控，安全可靠',
              explain:'报表分析、轻松管控',
              icon:'iconzu1547',
              img:require('../../../../public/images/enterprise/enterprise_enterprise_icon.png'),
          },
          {
              name:'系统用工少，效率高',
              explain:'数据赋能、采销决策',
              icon:'iconxitongyonggongshao',
              img:require('../../../../public/images/enterprise/enterprise_data_icon.png'),
          },
          {
              name:'大数据预计，自动化风控',
              explain:'实时预警、风险可控',
              icon:'icondashujuyuji',
              img:require('../../../../public/images/enterprise/enterprise_alert_icon.png'),
          },
        ],
        erpList:[
          {
              icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/finance/1.png',
              title:'在线融资，操作简单随借随还',
              explain:'金融服务入口直接连通客户ERP系统，实时在线融资，操作 简单、快捷',
          },
          {
              icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/finance/2.png',
              title:'赎货方便，秒级完成',
              explain:'ERP在线装车赎货或提前赎货，金融系统自动生成账单，付款后货权自动 放行，提货效率秒级完成',
          },
          {
              icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/finance/3.png',
              title:'费用账单，系统自动计算生成',
              explain:'融资赎货产生的相关费用，系统全部自动计算，无需人工干预，全流 程自动化，完全避免了人工计算出错。',
          },
          {
              icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/finance/4.png',
              title:'赎货付款，按提单付款或提前预付都可以',
              explain:'装车赎货时，可实时按装车金额付款，现金流更灵活；提前预付，可根据 估算当天出货量支付大概赎货金额，减少付款次数，赎货更方便。',
          },
          {
              icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/finance/5.png',
              title:'多系统集成，在线指令三方协同',
              explain:'金融系统+客户ERP系统+仓库仓储系统，多系统打通集成，所有做操 指令跨系统协同，方便高效。',
          },
          {
              icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/finance/6.png',
              title:'电子合同，在线签署管理简单',
              explain:'金融服务合同直接推送给客户ERP在线签署，融资单合同自动生成生效。',
          },
          {
              icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/finance/7.png',
              title:'发票管理，井然有序',
              explain:'收票管理，已收票、未收票一目了然，开票管理，已开票、未开票轻 松管理',
          },
          {
              icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/finance/8.png',
              title:'钱、物双控，线上、线下双闭环',
              explain:'金融系统控制着仓储系统的货权放行权限，收到钱自动放行，线上 控钱，下线控货。',
          },
          {
              icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/finance/9.png',
              title:'用工少，效率高',
              explain:'金融系统自动化程度高，人力干预只要负责确认收款，其他流程全部 系统完全，大大减少人力成本，提高工作效率，降低出错风险。',
          },
          {
              icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/finance/10.png',
              title:'大数据风控，自动化预警',
              explain:'金融系统通过对接仓储系统可以实时掌控市场行业动态变化，与 ERP系统对接，可以实时了解企业运营状况，实时控制金融业务 风险，通过价格预警、库存预警、市场预警、企业预警、订单到 期预警等方式实现自动化风控预警机制，让供应链金融服务更高 效、更安全。',
          }
        ],
      }
    },
    mounted(){
        this.$nextTick(() => {
            let wow = new WOW({
                boxClass: "wow",    //需要执行动画的元素的 class
                animateClass: "animated", // animation.css 动画的 class
                offset: 0, // 距离可视区域多少开始执行动画
                mobile: false, // 是否在移动设备上执行动画
                live: false // 异步加载的内容是否有效
            })
            wow.init()
        })
    },
    methods:{

    }
}
</script>

<style scoped  lang="scss">
  .homeTitle{border-bottom: 1px solid #E5E6EB;text-align: center;margin-top: 3rem;}
  .homeTitle .name{margin: 0 auto;margin-bottom:3px;line-height: 4.5rem;letter-spacing:0.1rem; font-size: 2.3rem;font-weight: 600;color: #333333;position: relative;}
  .homeTitle .name:after{content: '';width: 10rem;height: 2.7rem;background: #CEDCFF;display: block;border-radius: 0.5rem;transform: translateX(-50%);position: absolute;bottom: 0;left: 51.5%;z-index: -1;}
  .explain{text-align: center;color: #999999;}
  .homeContent{max-width: 120rem;margin: 0 auto;padding: 3rem 1rem;}
  .titmeName{text-align: center;margin: 3rem 0 0 0;}
  .titmeName .title{color: #333;font-weight: 600;font-size: 2.4rem;margin-bottom: 0.5rem;}
  .titmeName .explainTitle{color: #999999;font-weight: 600;font-size: 1.4rem;line-height: 2rem;}
  .one1{
      width: 100%;height: 50rem;
      position: relative;
      .icon{
          height: 100%;width: 100%;
      }
      .one1_content{
          width: 104rem;height: 65%;
          padding: 2rem 8rem;
          position: absolute;left: 50%;bottom: 0;transform: translateX(-50%); z-index: 2;
          border-top-left-radius: 0.6rem;
          border-top-right-radius: 0.6rem;
          color: #fff;
          .title_name{
              font-size: 4rem;
          }
          .title_name_one{text-indent: 10rem;font-weight: 500;}
          .title_name_two{text-indent: 10rem;font-size: 2.5rem;margin-top: 8rem;}
          .title_name_three{text-indent: 10rem;font-size: 2.5rem;margin-top: 1rem;}
          .title_list{font-size: 1.4rem;}
          .title_list li{margin-top: 1rem;}
      }
  }
  .enterprise{display: flex;justify-content: center;align-items: center; flex-direction: column;overflow: hidden;}
  .enterprise .content{width: 100%;}
  .enterprise_content{width: 120rem;margin: 0 auto;}
  .enterprise_one2{display: flex;flex-wrap: wrap;margin-top: 3rem;}
  .enterprise_one2 .item{width: 24rem;
      .item_content{border: 0.1rem solid #ddd;margin:0 -0.1rem -0.1rem 0;padding: 3rem 0; display: flex;flex-direction: column;align-items: center;
          .icon{color: #909EC5;font-size: 4rem;}
          .name{margin-top: 1rem;}
          .explain{color: #5D5D5D;}
      }
      .item_content:hover{box-shadow: 3px 3px 15px rgba(51, 51, 51, 0.1);cursor: pointer;border-top-color: #409EFF;}
  }

  .one3{margin-top: 3rem;
      .one3_content{
          background: #F5F6FA;
          height: 40rem;
          display: flex;
          .left{height: 100%;display: flex;align-items: center;flex: 1;padding-left: 2rem;}
          .right{height: 100%;flex: 1;display: flex;align-items: center;justify-content: center;}
      }
  }
  .one4{margin-top: 3rem;
      .one4_content{
          height: 40rem;
          display: flex;
          .left{height: 100%;display: flex;align-items: center;flex: 1;}
          .right{height: 100%;display: flex;align-items: center;flex: 1;padding-right: 2rem;}
      }
  }
  .item_list_content{
      padding: 0 10rem;
      text-align: left;
      .title{font-size: 2.2rem;}
      .explain{font-size: 1.4rem;color: #333;text-align: left;margin: 2rem 0;}
  }
</style>
